module.exports = __webpack_public_path__ + "static/ParqueAtracciones-79e8bc8a39c1226ad372c64f2891a0e6.jpg";